/**
 * @file:
 * @author: FJJ
 * @history:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2024/8/7      1.0     Second version
 *
 * 注意：
 *
 * Copyright 2021-2023, all rights reserved. Essa.cn
 * */
import React, {PureComponent,Fragment} from "react";
import {Spin,Drawer,Button,message,Popconfirm} from 'antd';
import FormFormat from '@components/FormFormat/FormFormat';
// import AuthBtn from "@components/HoverIcon/AuthBtn";
import Lang from "@/components/Lang/Lang";
import dayjs from "dayjs";
import FollowHistoryList from "./FollowHistoryList/FollowHistoryList";
import FollowUpAction from "./FollowUp.action"
import "./followUpDrawer.less";
import FollowAction from "../../pages/Customer/Follow/Follow.action";
// import NewBuyerLabel from "../../pages/Customer/Index/components/NewBuyerLabel";
import {NewBuyerLabel, TransactionCustomerStage,InternalBuyerLabel} from "../StatuLabel/statuBuyerLabel";

export default class FollowUpDrawer extends PureComponent {
    static defaultProps = {
        buyerInternalId:null,
        buyerId: "", // 显示
        labelType:"1010",//	1010:新客标签 1020:成交客户标签
    };
    constructor(props) {
        super(props);
        this.optionFields1 = [
            {
                name: 'id',  // 隐藏字段，必要
                hidden:true
            },
            {
                name:'buyerAccountId',
                cnTitle:'选择联系人',
                cnTitleId:'XuanZeLianXiRen',
                required: true,
                maxLength: 125,
                cnPlaceholder:'请选择',
                cnPlaceholderId:'QingXuanZe',
                width:216,
                type:"SearchSelect",
                hidden:this.props.labelType=='1030'?true:false,
                searchClass:{
                    api:"/service/mg/follower/buyer/user-list",
                    nameField:"email",
                    precondition:{id:props.buyerId},
                    idField:"buyAccountId",
                    initFirstOne:true
                },
            },
            {
                name:'followRemark',
                cnTitle:'本次跟进内容',
                cnTitleId:'BenCiGenJinNeiRong',
                required: true,
                maxLength: 512,
                type:"TextArea"
            },
            {
                name:'yFileList',
                cnTitle:'上传附件',
                cnTitleId:'ShangChuanFuJian',
                cnPlaceholderId:"QingXuanZe2",//请选择
                type:'UploadFileIcon',
                accept:'.jpg, .jpeg, .png, .bmp, .gif, .docx, .doc, .xlsx, .xls, .pdf',
                fileSizeLimit: 10*1024*1024,
                topTips: <div className={"black45 font_12 topMinus"}>{Lang({id:'GenJinWenJianShangChuan',default:'支持上传图片、word、excel、pdf。最多支持10个文件，每个文件大小限制10m'})}</div>,
                maxCount: 10,
                // typeUpload:"display"
            },
            {
                type:"OnlyRender",
                showTitle:false,
                title:" ",
                onlyRender: (<div className={"black89 fw_500 font_18 mb_12 flex-item-between"}>{Lang({id:"XiaCiGenJin",default:"下次跟进"})}
                    <Popconfirm
                        title={Lang({id:"QueRenBuZaiGenJin",default:"确认不再跟进？"})}
                        onConfirm={()=>this.cancelFollower()}
                        okText={Lang({id:'QueDing', default:'确定'})}
                        cancelText={Lang({id:'QuXiao', default:'取消'})}
                    >
                        <span className={"font_14 fw_400 color-blue3 cursor-p"}>{Lang({id:"BuZaiGenJin",default:"不再跟进"})}</span>
                    </Popconfirm>
                </div>)
            },
            {
                name:'nextFollowDate',
                cnTitle:'下次跟进日期',
                cnTitleId:'XiaCiGenJinRiQi',
                type:'Date',
                cnPlaceholder: '选择日期',
                cnPlaceholderId: 'XuanZeRiQi',
                disabledDate: (current)=>current && current < dayjs().startOf('day'),
                // required: true
            },
            {
                name:'nextFollowRemark',  // 下次跟进内容备忘
                cnTitleId:'XiaCiGenJinNeiRongBeiWang',
                maxLength: 512,
                type:"TextArea"
            },
            {
                name:'yNextFollowFileList',
                cnTitle:'上传附件',
                cnTitleId:'ShangChuanFuJian',
                cnPlaceholderId:"QingXuanZe2",//请选择
                type:'UploadFileIcon',
                accept:'.jpg, .jpeg, .png, .bmp, .gif, .docx, .doc, .xlsx, .xls, .pdf',
                fileSizeLimit: 10*1024*1024,
                topTips: <div className={"black45 font_12 topMinus"}>{Lang({id:'GenJinWenJianShangChuan',default:'支持上传图片、word、excel、pdf。最多支持10个文件，每个文件大小限制10m'})}</div>,
                maxCount: 10,
            },
        ];
        this.optionFields2 = [
            {
                name: 'id',  // 隐藏字段，必要
                hidden:true
            },
            {
                name:'followRemark',
                cnTitle:'本次跟进内容',
                cnTitleId:'BenCiGenJinNeiRong',
                required: true,
                maxLength: 512,
                type:"TextArea"
            },
            {
                name:'yFileList',
                cnTitle:'上传附件',
                cnTitleId:'ShangChuanFuJian',
                cnPlaceholderId:"QingXuanZe2",//请选择
                type:'UploadFileIcon',
                accept:'.jpg, .jpeg, .png, .bmp, .gif, .docx, .doc, .xlsx, .xls, .pdf',
                fileSizeLimit: 10*1024*1024,
                topTips: <div className={"black45 font_12 topMinus"}>{Lang({id:'GenJinWenJianShangChuan',default:'支持上传图片、word、excel、pdf。最多支持10个文件，每个文件大小限制10m'})}</div>,
                maxCount: 10,
                // typeUpload:"display"
            },
            {
                name:'isFollowFail',
                cnTitle:'跟进失败',
                cnTitleId:'GenJinShiBai',
                type:"BtnSelect",
                canClear:true,
                list:[{
                    name:'是',
                    code:1
                }],
            },
            {
                type:"OnlyRender",
                showTitle:false,
                title:" ",
                onlyRender: (<div className={"black89 fw_500 font_18 mb_12 flex-item-between"}>{Lang({id:"XiaCiGenJin",default:"下次跟进"})}
                    <Popconfirm
                        title={Lang({id:"QueRenBuZaiGenJin",default:"确认不再跟进？"})}
                        onConfirm={()=>this.cancelFollower()}
                        okText={Lang({id:'QueDing', default:'确定'})}
                        cancelText={Lang({id:'QuXiao', default:'取消'})}
                    >
                        <span className={"font_14 fw_400 color-blue3 cursor-p"}>{Lang({id:"BuZaiGenJin",default:"不再跟进"})}</span>
                    </Popconfirm>
                </div>)
            },
            {
                name:'nextFollowDate',
                cnTitle:'下次跟进日期',
                cnTitleId:'XiaCiGenJinRiQi',
                type:'Date',
                cnPlaceholder: '选择日期',
                cnPlaceholderId: 'XuanZeRiQi',
                disabledDate: (current)=>current && current < dayjs().startOf('day'),
                // required: true
            },
            {
                name:'nextFollowRemark',  // 下次跟进内容备忘
                cnTitleId:'XiaCiGenJinNeiRongBeiWang',
                maxLength: 512,
                type:"TextArea"
            },
            {
                name:'yNextFollowFileList',
                cnTitle:'上传附件',
                cnTitleId:'ShangChuanFuJian',
                cnPlaceholderId:"QingXuanZe2",//请选择
                type:'UploadFileIcon',
                accept:'.jpg, .jpeg, .png, .bmp, .gif, .docx, .doc, .xlsx, .xls, .pdf',
                fileSizeLimit: 10*1024*1024,
                topTips: <div className={"black45 font_12 topMinus"}>{Lang({id:'GenJinWenJianShangChuan',default:'支持上传图片、word、excel、pdf。最多支持10个文件，每个文件大小限制10m'})}</div>,
                maxCount: 10,
            },
        ];
        this.state = {
            loading: false,
        }
    }
    /**
     * 抽屜
     * */
    showDrawer = (flag=true) => {
        if(this.props.showDrawer){ // 打开抽屉后回调
            this.props.showDrawer(flag)
        }
        this.setState({
            visibleFollowStageDrawer: flag,
        });
        if(flag){
            this.getCustomer()
        }else {
            this.setState({
                cusModel:{}
            })
        }
    }
    /**
     * 客户信息
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=210#6052
     */
    getCustomer() {
        this.loading(true);
        const {buyerId,buyerInternalId} = this.props;
        let api ='/service/mg/follower/user/buyerId';
        let postData = {
            id:buyerId
        }
        if(this.props.labelType=='1030'){
            api = '/service/mg/follower/potential/buyer/detail';
            postData = {
                id:buyerInternalId
            }
        }
        FollowAction.postAction(api,postData).then(res=>this.getCustomerRes(res.data)).catch(err=>this.getCustomerRes(err));
    }
    getCustomerRes(res){
        this.loading(false);
        const {success,valid,model,} = res;
        if (success && valid) {
            this.setState({
                cusModel:model
            })
        }
    }
    showHistory(flag){
        this.setState({
            visHistory: flag,
        });
    }
    async postData(){
        const res = await this.onRefFormFormat.handleOK();
        if(res&&res.success) {
            const valueObj = res.data;
            if(valueObj.yFileList&&valueObj.yFileList.length>0){
                let list = [];
                valueObj.yFileList.forEach(fil=>list.push({
                    id:fil.fileId,
                    extend:fil.extend,
                    url:fil.fileUrl,
                }))
                valueObj["fileList"] = list;
                delete valueObj.yFileList;
            }
            if(valueObj.yNextFollowFileList&&valueObj.yNextFollowFileList.length>0){
                let list = [];
                valueObj.yNextFollowFileList.forEach(fil=>list.push({
                    id:fil.fileId,
                    extend:fil.extend,
                    url:fil.fileUrl,
                }))
                valueObj["nextFollowFileList"] = list
                delete valueObj.yNextFollowFileList;
            }
            if(valueObj.yFileList&&valueObj.yFileList.length>0){
                let list = [];
                valueObj.yFileList.forEach(fil=>list.push({
                    id:fil.id,
                    extend:fil.extend,
                    url:fil.fileUrl,
                }))
                valueObj["fileList"] = list;
                delete valueObj.yFileList;
            }
            if(valueObj.nextFollowDate){
                valueObj.nextFollowTime = (dayjs(valueObj.nextFollowDate).endOf('day').valueOf())-999; //时间;
                delete valueObj.nextFollowDate;
            }
            this.submit(valueObj);
        }
    }
    /**
     * 提交
     **/
    submit(valueObj){
            const {buyerId,buyerInternalId} = this.props;
            this.loading(true);
            let api = "/service/mg/follower/follow/save";
            let postData = {...valueObj,
                buyerId: buyerId,
            };
            if(this.props.labelType=='1030'){
                api = '/service/mg/follower/follow/save';
                postData = {
                    ...valueObj,
                    buyerInternalId:buyerInternalId
                }
            }
            FollowUpAction.postHttpAction(api, postData).then((resp)=>this.handleRes(resp.data)).catch(err=>this.handleRes(err));
    }
    handleRes(res={}){
        const {success,valid,} = res;
        if (success && valid) {
            message.success(Lang({id:"BaoCunChengGong",default:"保存成功"}));
            if(this.props.refreshPage){
                this.props.refreshPage()
            }
            this.showTimer =  setTimeout(()=>{
                this.setState({
                    reSetForm:true
                },()=>{
                    this.loading(false);
                    this.setState({
                        reSetForm:false
                    })
                })

            },100)
            this.onReChildHistoryList.getList();
        }else {
            this.loading(false);
            if(res.message)message.error(res.message);
        }
    }

    /*
     * 取消跟进
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=210#8302
     * */
    cancelFollower(){
        const {buyerId,buyerInternalId} = this.props;
        this.loading(true);
        let api = "/service/mg/follower/cancel-follower";
        let postData = {
            buyerId: buyerId,
        };
        if(this.props.labelType=='1030'){
            api = '/service/mg/follower/save-potential-buyer-cancel-follow';
            postData = {
                id:buyerInternalId
            }
        }
        FollowAction.postAction(api, postData).then(res => this.handleRes(res.data)).catch(err => this.handleFollowerRes(err));
    }
    handleFollowerRes(res={}){
        const {success,valid,} = res;
        if (success && valid) {
            message.success(Lang({id:"CaoZuoChengGong",default:"操作成功"}));
            if(this.props.refreshPage){
                this.props.refreshPage()
            }
            this.showDrawer(false);
        }else {
            this.loading(false);
            if(res.message)message.error(res.message);
        }
    }
    loading(flag){
        this.setState({
            loading:flag
        })
    }
    onRefForm = (ref) =>  this.onRefFormFormat = ref;
    onRefHistoryList = (ref) =>  this.onReChildHistoryList = ref;
    componentWillMount() {
    }
    componentDidMount() {
        if (this.props.onRef) this.props.onRef(this);
    }
    componentWillUnmount = () => {
        this.setState = (state, callback) => {
            return;
        };
        if(this.showTimer)clearTimeout(this.showTimer)
    };
    componentWillReceiveProps(nextProps, nextContext) {
    }

    render() {
        const {buyerId,visibleFollowUpDrawer=false,labelType,buyerInternalId } = this.props;
        const {loading = true,visHistory=true, reSetForm=false,cusModel={}} = this.state;
        const sCountryUrl =cusModel.abbreviate?require('../../assets/img/country/'+cusModel.abbreviate + '.png'):"";
        return (<Fragment>
            {/*{children?<span onClick={()=>this.showDrawer(true)}>{children}</span>:<AuthBtn icon={"ri-draft-line"} tips = {Lang({id:"GenJin",default:"跟进"})}*/}
                     {/*showDot={true}*/}
                     {/*onClick={()=>this.showDrawer(true)}*/}
                     {/*className={"blueIconTips"}  />}*/}
            <Drawer title={<div className={"flex-item-ver-center lineH_27"}>
                                <span className={"font_18 fw_500"}>{Lang({id:"GenJinKeHu",default:"跟进客户"})}</span>
                                <i className={"ri-history-line ml_8 black66 font_20 fw_400 cursor-p"}
                                    onClick={()=>this.showHistory(!visHistory)} />
                        </div>}
                    width={1100}
                    rootClassName={"followUpDrawerWrap"}
                    maskClosable={false}
                    destroyOnClose={true}
                    onClose={()=>this.showDrawer(false)}
                    open={visibleFollowUpDrawer}>
                        <Spin spinning={loading}>
                            <div className={"flex-item"}>
                                <div className={"editForm"}>
                                    <div className={"flex-item-between mb_12"}>
                                        <div className={"black89 font_14"}>
                                            <div className={"flex-item-ver-center lineH_27"}>
                                                {cusModel.abbreviate?<img className="mr_4" src={sCountryUrl.default} width={24} />:null}
                                                <span className={"fw_700 font_18"}>{cusModel.code||"-"}</span>
                                            </div>
                                            {
                                                labelType!="1030"?<div className={"black45 lineH_21"}>{cusModel.name}</div>:null
                                            }
                                        </div>

                                        {labelType=="1010"&&<NewBuyerLabel statusCode={cusModel.newBuyerLabelDictCode} status={cusModel.newBuyerLabelName} buyerId={buyerId} />}
                                        {labelType=="1020"&&<TransactionCustomerStage
                                            statusCode={cusModel.buyerLabelDictCode} status={cusModel.buyerLabelName}
                                        />}
                                        {labelType=="1030"&&<InternalBuyerLabel statusCode={cusModel.mgFollowStatus} status={cusModel.mgFollowStatusName}/>}

                                    </div>
                                    {!reSetForm&&<FormFormat onRef={this.onRefForm}
                                                formLayout="vertical"
                                                options={this.props.labelType==='1030'?this.optionFields2:this.optionFields1}
                                    />}

                                    <Button type="primary" onClick={()=>this.postData()} loading={loading}>
                                        <Lang id="BaoCun">{Lang({id:"BaoCun",default:"保存"})}</Lang>
                                    </Button>
                                </div>
                                <div className={"historyList ml_8"} style={{"display":(visHistory?"block":"none")}}>
                                    <FollowHistoryList showAdd={false} buyerId={buyerId} buyerInternalId={buyerInternalId} onRef={this.onRefHistoryList}
                                                       openDrawerCallBack={()=>this.showDrawer(false)} />
                                </div>
                            </div>
                    </Spin>
            </Drawer>
        </Fragment>);
    }
}
